import { Injectable } from '@angular/core';

import { TmsWebBaseEditService } from 'tms-web-shared';
import { Machine } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class MachineService extends TmsWebBaseEditService<Machine, Machine> {
  constructor() {
    super('Machine', $localize`Machine`);
  }
}
